import { Box, Paper, Typography } from "@mui/material";

const TLPaymentVoucher = () => (
  <Box m={{ xs: 1.5, md: 3 }}>
    <Typography variant="h3" fontWeight={800}>Payment Voucher</Typography>
    <Typography color="text.secondary" mb={2}>Manage payment voucher transactions.</Typography>
    <Paper
      elevation={0}
      sx={{ minHeight: 420, p: 3, border: "1px solid", borderColor: "divider", borderRadius: 3 }}
    >
      <Typography color="text.secondary">The Payment Voucher transaction list will be displayed here.</Typography>
    </Paper>
  </Box>
);

export default TLPaymentVoucher;
